import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Readmore from "./pages/Readmore";
import { HOME_PATHS, HOME_SECTIONS } from "./routes";

/** Pages other than the home page always open at the top. */
function ScrollToTopOnPageChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!(pathname.toLowerCase() in HOME_SECTIONS)) window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTopOnPageChange />
      <NavBar />
      <main>
        <Routes>
          {HOME_PATHS.map((path) => (
            <Route key={path} path={path} element={<Home />} />
          ))}
          <Route path="/About" element={<About />} />
          <Route path="/Readmore" element={<Readmore />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}
